module.exports = __webpack_public_path__ + "static/media/VIA0.f8e45f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/digitalAssistant/assets/VIA0.png
// module id = 564
// module chunks = 1